import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CollapseToggleComponent } from './collapse-toggle.component';
import { FrontendIconsModule } from '@tablesready/frontend-icons';

@NgModule({
  declarations: [CollapseToggleComponent],
  exports: [CollapseToggleComponent],
  imports: [CommonModule, FrontendIconsModule],
})
export class CollapseToggleModule {}
